import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const PuntosEscala = () => {
  // Obtiene el estado y la función para actualizarlo desde el contexto
  const { promptData, setPromptData } = useActividadesContext();

  // Función para manejar el cambio en la selección de radio buttons
  const handlePuntosEscala = (event) => {
    const puntosEscala = event.target.value;
    setPromptData((prevData) => ({
      ...prevData,
      // Convertir el valor a número antes de actualizar el estado
      nivel_desempeno: Number(puntosEscala),
    }));
  };

  return (
    <Grid item xs={12} display={"flex"} flexDirection={"column"} mb={3}>
      {/* Título del componente */}
      <Typography
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        Niveles de desempeño *
      </Typography>
      {/* Descripción */}
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Indica el número de niveles de desempeño que deseas incluir en tu
        rúbrica. Los niveles de desempeño permiten evaluar el grado de
        cumplimiento de los criterios por parte de los estudiantes.
      </FormLabel>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="niveles de desempeño"
          name="nivel_desempeno"
          value={promptData.nivel_desempeno}
          onChange={handlePuntosEscala}
        >
          <FormControlLabel
            value="3"
            control={<Radio sx={{ color: "#336B87" }} />}
            label={
              <Typography
                sx={{
                  fontFamily: "montserrat",
                  fontSize: "0.8rem",
                  color: "#336B87",
                }}
              >
                3
              </Typography>
            }
          />
          <FormControlLabel
            value="4"
            control={<Radio sx={{ color: "#336B87" }} />}
            label={
              <Typography
                sx={{
                  fontFamily: "montserrat",
                  fontSize: "0.8rem",
                  color: "#336B87",
                }}
              >
                4
              </Typography>
            }
          />
          <FormControlLabel
            value="5"
            control={<Radio sx={{ color: "#336B87" }} />}
            label={
              <Typography
                sx={{
                  fontFamily: "montserrat",
                  fontSize: "0.8rem",
                  color: "#336B87",
                }}
              >
                5
              </Typography>
            }
          />
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};

export default PuntosEscala;
